var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.5,383.9h-55c-9.1,0-16.5-7.4-16.5-16.5v-55c0-4.4,1.7-8.6,4.8-11.7L300,133.4c6.1-6.1,17.3-6.1,23.4,0 l55,55c3.1,3.1,4.8,7.3,4.8,11.7c0,4.4-1.7,8.6-4.8,11.7L211.2,379C208.1,382.1,203.9,383.9,199.5,383.9z M148.1,363.8H198 l163.6-163.6l-49.9-49.9L148.1,313.8V363.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.6,4C116.2,4,3.3,117,3.3,256.4s113,252.4,252.4,252.4S508,395.8,508,256.4S395,4,255.6,4z M255.6,495.1 c-131.8,0-238.7-106.9-238.7-238.7S123.8,17.7,255.6,17.7s238.7,106.9,238.7,238.7S387.5,495.1,255.6,495.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd64b148e1aa0dd5ba22c65212855961.svg";
export { ForwardRef as ReactComponent };